import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import "../../manufacturer/manufacturer.css";
import TableContainer from "../../../components/layout/table-container/table-container";
import TablePagination from "../../../components/Pagination/tablePagination";
import { superAdminroleList } from "../../../redux/actions/superAdminActions";
import SuperUserRoleListTableData from "./super-user-role-list-table-data";
import LoadingSpinnerTable from "../../../components/utilites/loaderSpinningContainer";
import { useNavigate, useParams } from "react-router-dom";
import NumberPagination from "../../../components/Pagination/number-pagination";

const SuperUserRoleListTable = ({ search, page_no }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [superRoleListData, setSuperRoleListData] = useState([]);
  const [page, setPage] = useState(page_no ?? 1);
  const [loading, setLoading] = useState(false);

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    setLoading(true);
    dispatch(superAdminroleList({ search, page }, onSuccess, onError));
  }, [page, search]);

  const fetchSuperAdminList = () => {
    dispatch(superAdminroleList({ search, page }, onSuccess, onError));
  };

  const onSuccess = (data) => {
    setLoading(false);
    setSuperRoleListData(data.data.data);
    console.log(data.data.data);
  };

  const onError = (err) => {
    setLoading(false);
    console.log(err);
  };

  return (
    <>
      <TableContainer>
        <thead>
          <tr className="table-rows color_747f9e">
            <th className="table-heads " width={"4%"}>
              #
            </th>
            <th className="table-heads " width={"10%"}>
              Role ID
            </th>
            <th className="table-heads " width={"10%"}>
              Role Name
            </th>
            <th className="table-heads " width={"10%"}>
              Role Level
            </th>
            <th className="table-heads " width={"22%"}>
              Actions
            </th>
          </tr>
        </thead>
        <tbody style={{ position: "relative" }}>
          {loading == true ? (
            <div className="list-spinner-container">
              <LoadingSpinnerTable show={loading} />
            </div>
          ) : superRoleListData?.roles?.length > 0 ? (
            <>
              {superRoleListData?.roles?.map((eachRow, index) => (
                <SuperUserRoleListTableData
                  key={eachRow.id}
                  data={eachRow}
                  index={index}
                  fetchSuperAdminList={fetchSuperAdminList}
                  currentPage={superRoleListData?.pagination?.currentPage}
                />
              ))}
            </>
          ) : (
            <tr>
              <td colSpan="1" className="text-center no-data-container fs_16">
                <span>~ No Data Found ~</span>
              </td>
            </tr>
          )}
        </tbody>
      </TableContainer>
      {superRoleListData?.pagination?.totalPages > 0 && (
        <NumberPagination
          setCurrentPage={setPage}
          pagination={superRoleListData?.pagination?.currentPage}
          totalPages={superRoleListData?.pagination?.totalPages}
          path={"/super-user/role"}
          filters={`${queryString}`}
        />
      )}
    </>
  );
};

export default SuperUserRoleListTable;
